import { h } from 'preact';

import { SadlibAd } from '../../../../pieces/sadlib-ad';
import { TopBar } from '../../../../pieces/topbar';

import { Column, Row, ContainerFluid } from '@cube/layout';
import { MobileHeader } from '@cube/header-widget';
import { PressWidget } from '@cube/finance-components';

export const Phone = ({ pageConfig, ...props }) =>
	(
		<div>
			<MobileHeader
				{...props}
				{...pageConfig.header}
			/>
			<TopBar
				type="finance"
			/>
			<ContainerFluid>
				<Row>
					<Column>
						<PressWidget />
					</Column>
				</Row>
				<SadlibAd id="adhesion" />
			</ContainerFluid>
		</div>
	);
